/**
 * @desc 库存调整单确认执行
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/stockAdjustmentMaster/affirm`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
